import React from 'react';
import { NavLink } from 'redux-first-router-link';

import { LocaleString } from '@biw/intl';

import Logo from './logo';
import UserDetails from './user-details';

import './header.scss';

interface Props {
    authenticated: boolean;
    clientLogo: string;
    hideNav: boolean;
}

export default class Header extends React.Component<Props> {
    public static defaultProps = {
        hideNav: false,
    };

    public render() {
        const {
            authenticated,
            clientLogo,
            hideNav,
        } = this.props;

        const showNav = !!authenticated && !hideNav;
        return (
            <header className={authenticated ? 'site-header' : 'site-header external'}>
                <div className="content-container">
                    <Logo className="left-container" companyLogo={clientLogo} showNav={showNav} />
                    { showNav ?
                        <div className="user-info right-container">
                            <UserDetails />
                        </div>
                    :
                        <div className="header-content">
                            <NavLink to="/login" className="login-link" id="login">
                                <span aria-hidden="true" className="hidden"><LocaleString code="header.login"/></span>
                                <LocaleString code="header.login" />
                            </NavLink>
                        </div>
                    }
                </div>
            </header>

        );
    }
}
